import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { TranslateModule } from "@ngx-translate/core";
import { DialogFrameModule } from "src/app/common/components/dialog-frame/dialog-frame.module";
import { AudioPlayerComponent } from "src/app/shared/ui/audio-player/audio-player.component";
import { LaunchpadTileConfig } from "../../container/launchpad.interfaces";

@Component({
  selector: "tpm-storyteller-dialog",
  templateUrl: "storyteller-dialog.component.html",
  styleUrls: ["storyteller-dialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, TranslateModule, DialogFrameModule, MatDialogModule, AudioPlayerComponent]
})
export class StorytellerDialogComponent {
  public readonly data: LaunchpadTileConfig["storyTeller"] & { title: string } = inject(MAT_DIALOG_DATA);
}
